import {baseUrl} from "../../requests/NetworkRequestAuth0";

export const uri = "/api/vt";

export const pushVTContact = (email, name, phone, companyName, message, successMethod, errorMethod) => {
    const params = {
        email: email,
        name: name,
        phone: phone,
        companyName: companyName,
        message: message
    };
    return fetch(baseUrl + uri + "/push/contact", fetchConfig(params))
        .then(function (response) {
            //console.log(response);
            //debugger;
            return response.json();
        })
        .then(responseJson => {
            responseJson && successMethod(responseJson)
            return true;
        })
        .catch(error => {
            // console.log("ERROR IS");
            // console.log(error);
            errorMethod(true);
        });

};

export const fetchConfig = (myBody = {}) => {
    let httpHeaders = new Headers({});
    httpHeaders.append("Content-Type", "application/json");
//  const timeZoneOffset = (new Date().getTimezoneOffset() / 60) * -1;
//  myHeaders.append("user-timezone-offset", timeZoneOffset);

    return {
        method: "POST",
        headers: httpHeaders,
        //mode: 'cors',
        //cache: "default",
        cache: "no-store",
        body: JSON.stringify(myBody)
    };
};

// export const findUserVirtualTipz = (
//     venueId,
//     successMethod,
//     errorMethod
// ) => {
//     fetchGet(
//         uri + "/user/vt/venue/" + venueId ,
//         successMethod,
//         errorMethod);
// };

// export const findVenueById = (
//     venueId,
//     successMethod,
//     errorMethod
// ) => {
//     fetchGet(
//         uri + "/venue/" + venueId,
//         successMethod,
//         errorMethod);
// };

// export const findDancerTips = (
//     dancerId,
//     successMethod,
//     errorMethod
// ) => {
//     fetchGet(
//         uri + "/dancer/" + dancerId + "/tips",
//         successMethod,
//         errorMethod);
// };

// export const findVenueSellPurchaseHistory = (
//     venueId,
//     month,
//     year,
//     successMethod,
//     errorMethod
// ) => {
//     fetchGet(
//         uri + "/venue/" + venueId + "/purchase/history/" + month + "/" + year,
//         successMethod,
//         errorMethod);
// };

// export const findVenueSellPurchases = (
//     venueId,
//     month,
//     year,
//     successMethod,
//     errorMethod
// ) => {
//     fetchGet(
//         uri + "/venue/" + venueId + "/purchases/" + month + "/" + year,
//         successMethod,
//         errorMethod);
// };

// export const findVenueSellPurchasesLimit = (
//     venueId,
//     successMethod,
//     errorMethod
// ) => {
//     fetchGet(
//         uri + "/venue/" + venueId + "/purchases",
//         successMethod,
//         errorMethod);
// };

